import { Box, Circle, HStack, Square, Text, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { PROTECTED_PATHS } from '../../../app/constants';
import { PrimaryButton } from '../../../components/CustomButton';
import CustomModal from '../../../components/CustomModal';
import { FaWallet } from 'react-icons/fa';
import RedirectToPaymentPageModal from './RedirectToPaymentPageModal';

const DebitCard = ({ setReload, wallet }) => {
  const navigate = useNavigate();
  const { ESTATE_DUE } = PROTECTED_PATHS;

  return (
    <>
      <Square className='wallet-debit-card' borderRadius='8px' h='200px' w='100%' color='#eee'>
        <HStack justify='space-between' px='5' pt='24%' w='100%'>
          <Box>
            <Text as='small' m='0'>
              CURRENT BALANCE
            </Text>
            <Text fontSize='1.5rem' lineHeight={1}>
              {Number(wallet?.balance)?.toFixed(2)}
              <Text as='span' fontSize='12px'>
                points
              </Text>
            </Text>
          </Box>

          <CustomModal div btnTitle={<BuyPoints />}>
            <RedirectToPaymentPageModal setReload={setReload} />
          </CustomModal>
        </HStack>
      </Square>{' '}
      <Box py='5'>
        <PrimaryButton shadow='sm' btnText='Pay Estate Due' onClick={() => navigate(ESTATE_DUE)} />
      </Box>
      {/* <HStack gap='2rem' py='3' justify='space-between'>
        <CustomModal
          btnTitle='withdraw funds'
          buttonProps={{ ...fundsBtnStyles }}
        >
          <WithdrawFunds />
        </CustomModal>

        <CustomModal
          btnTitle='Transfer funds'
          buttonProps={{ ...fundsBtnStyles }}
        >
          <TransaferFunds />
        </CustomModal>
      </HStack> */}
    </>
  );
};

export default DebitCard;

// const fundsBtnStyles = {
//   color: 'primary',
//   bg: 'lightPink',
//   border: 'solid 1px #FBD5D3',
//   size: 'sm',
//   px: '6',
// };

const BuyPoints = () => {
  return (
    <VStack>
      <Circle h='30px' w='30px' border='1px solid #ddd'>
        <FaWallet />
      </Circle>
      <Text as='small' m='0'>
        Buy Points
      </Text>
    </VStack>
  );
};
